<template>
  <div>
    <Select
      :model-value="value"
      class="w-full"
      :label="t('insuranceCasePrices')"
      :options="options"
      empty-value-to="null"
      @update:model-value="handleUpdate($event as InsuranceCaseProvider)"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Select from '@/components/Select.vue';
import { useInsuranceProviderOptions } from '@/views/insurance-cases/insurance-case/use-insurance-provider-options';

export type InsuranceCaseProvider = 'roland' | 'axa' | 'europ' | 'volvo' | 'jlr' | null;

defineProps<{
  value: InsuranceCaseProvider;
}>();

const emit = defineEmits<{
  (event: 'change', value: InsuranceCaseProvider): void;
}>();

const { t } = useI18n();

const options = useInsuranceProviderOptions(
  true,
  computed(() => t('standardPrices')),
);

const handleUpdate = (value: InsuranceCaseProvider) => {
  emit('change', value);
};
</script>

<i18n lang="json">
{
  "en": {
    "useInsuranceCasePrices": "Use insurance case prices",
    "insuranceCasePrices": "Insurance case prices",
    "standardPrices": "Standard prices"
  },
  "de": {
    "useInsuranceCasePrices": "Versicherungsfallpreise nutzen",
    "insuranceCasePrices": "Versicherungsfallpreise",
    "standardPrices": "Standardpreise"
  },
  "es": {
    "useInsuranceCasePrices": "Usar precios del siniestro",
    "insuranceCasePrices": "Precios del siniestro",
    "standardPrices": "Precios estándar"
  }
}
</i18n>
